import React, { ComponentProps } from 'react';
import { transformToCdnUrl } from 'utils/google-storage-util';
import { PackageProviderName } from '../../../data/ppoints/constants';

export const getPackageProviderIconUrl = (provider: PackageProviderName): string => {
    let iconUrl = '';

    switch (provider) {
        case PackageProviderName.FOXPOST:
        case PackageProviderName.KVIKK_FOXPOST:
            iconUrl = transformToCdnUrl('shipping-providers-logos/foxpost-packeta-group.webp');
            break;
        case PackageProviderName.MPL_PACKAGE_POINT:
        case PackageProviderName.MPL_DELIVERY:
        case PackageProviderName.KVIKK_MPL:
            iconUrl = transformToCdnUrl('shipping-providers-logos/magyar-posta-mpl.webp');
            break;
        case PackageProviderName.MPL_COOP:
            iconUrl = transformToCdnUrl('shipping-providers-logos/coop.svg');
            break;
        case PackageProviderName.MPL_MOL:
            iconUrl = transformToCdnUrl('shipping-providers-logos/mol.svg');
            break;
        case PackageProviderName.MPL_MEDIAMARKT:
            iconUrl = transformToCdnUrl('shipping-providers-logos/mediamarkt.svg');
            break;
        case PackageProviderName.MPL_OFFICE:
            iconUrl = transformToCdnUrl('shipping-providers-logos/posta_32x32.png');
            break;
        case PackageProviderName.GLS:
        case PackageProviderName.KVIKK_GLS:
        case PackageProviderName.GLS_POLAND:
        case PackageProviderName.GLS_GLOBAL:
        case PackageProviderName.GLS_FI:
        case PackageProviderName.GLS_IT:
        case PackageProviderName.GLS_BG:
        case PackageProviderName.GLS_BE:
        case PackageProviderName.GLS_FR:
        case PackageProviderName.GLS_NL:
        case PackageProviderName.GLS_LU:
        case PackageProviderName.GLS_DE:
        case PackageProviderName.GLS_ES:
        case PackageProviderName.GLS_PT:
        case PackageProviderName.GLS_AT:
        case PackageProviderName.GLS_GR:
        case PackageProviderName.GLS_DK:
            iconUrl = transformToCdnUrl('shipping-providers-logos/gls.webp');
            break;
        case PackageProviderName.PACKETA:
        case PackageProviderName.KVIKK_PACKETA:
            iconUrl = transformToCdnUrl('shipping-providers-logos/packeta.webp');
            break;
        case PackageProviderName.DPD:
        case PackageProviderName.KVIKK_DPD:
        case PackageProviderName.DPD_POLAND:
        case PackageProviderName.DPD_GLOBAL:
        case PackageProviderName.DPD_GREECE:
        case PackageProviderName.DPD_ITALY:
        case PackageProviderName.DPD_SLOVENIA:
        case PackageProviderName.DPD_GB:
        case PackageProviderName.DPD_LATVIA:
        case PackageProviderName.DPD_PORTUGAL:
        case PackageProviderName.DPD_SLOVAKIA:
        case PackageProviderName.DPD_BULGARIA:
        case PackageProviderName.DPD_SWEDEN:
        case PackageProviderName.DPD_GERMANY:
        case PackageProviderName.DPD_CZECH_REPUBLIC:
        case PackageProviderName.DPD_LUXEMBOURG:
        case PackageProviderName.DPD_SPAIN:
        case PackageProviderName.DPD_SWITZERLAND:
        case PackageProviderName.DPD_AUSTRIA:
        case PackageProviderName.DPD_BELGIUM:
        case PackageProviderName.DPD_NETHERLANDS:
        case PackageProviderName.DPD_ROMANIA:
        case PackageProviderName.DPD_ESTONIA:
        case PackageProviderName.DPD_FRANCE:
        case PackageProviderName.DPD_LITHUANIA:
            iconUrl = transformToCdnUrl('shipping-providers-logos/dpd.webp');
            break;
        case PackageProviderName.SPRINTER:
            iconUrl = transformToCdnUrl('shipping-providers-logos/sprinter-pickpackpoint.webp');
            break;
        case PackageProviderName.TOURMIX:
            iconUrl = transformToCdnUrl('shipping-providers-logos/tourmix.webp');
            break;
        case PackageProviderName.ECONT:
        case PackageProviderName.ECONT_ROMANIA:
            iconUrl = transformToCdnUrl('shipping-providers-logos/econt.webp');
            break;
        case PackageProviderName.FEDEX_HOLD_AT_LOCATION:
            iconUrl = transformToCdnUrl('shipping-providers-logos/fedex.webp');
            break;
        case PackageProviderName.FAN_COURIER_INTERNATIONAL:
            iconUrl = transformToCdnUrl('shipping-providers-logos/fan_courier.webp');
            break;
        default:
            iconUrl = transformToCdnUrl('shipping-providers-logos/' + provider + '.webp');
            break;
    }

    return iconUrl;
};

export const PackageProviderIcon: React.FC<PackageProviderIconProps> = ({ provider, size = 'base' }) => {
    return <s-thumbnail size={size} src={getPackageProviderIconUrl(provider)} alt={provider} />;
};

type PackageProviderIconProps = {
    provider: PackageProviderName;
    /** `s-thumbnail`'s size, `base` by default */
    size?: ComponentProps<'s-thumbnail'>['size'];
};
